<template>
  <div class="financial-page">
    <div class="page-header">
      <span class="page-title">财务管理</span>
    </div>

    <div class="info-card mt20">
      <div class="info-card-head">
        <span class="info-card-title">筛选查询</span>
      </div>
      <el-form :inline="true" ref="search" :model="search" class="mt15">
        <el-form-item prop="order_no">
          <el-input v-model="search.order_no" placeholder="请输入订单编号" clearable></el-input>
        </el-form-item>
        <el-form-item prop="cash_flow_type">
          <el-select v-model="search.cash_flow_type" placeholder="请选择金额类型" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option v-for="option in OrderPayTypeStatus" :key="option.val" :label="option.label"
                       :value="option.val"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="rangeDate">
          <el-date-picker
            v-model="search.rangeDate"
            type="daterange"
            align="right"
            unlink-panels
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="user_name">
          <el-input v-model="search.user_name" placeholder="请输入患者名字" clearable></el-input>
        </el-form-item>
        <el-form-item prop="tel">
          <el-input v-model="search.tel" placeholder="请输入患者手机号" clearable></el-input>
        </el-form-item>
        <el-form-item prop="hospital_name">
          <el-input v-model="search.hospital_name" placeholder="请输入医院" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="searchData">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetForm('search')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="stat-row mt20">
      <div class="stat-card stat-receivable">
        <div class="stat-icon"><i class="el-icon-wallet"></i></div>
        <div class="stat-info">
          <div class="stat-label">应收</div>
          <div class="stat-value">¥ {{ pay_total }}</div>
        </div>
      </div>
      <div class="stat-card stat-profit">
        <div class="stat-icon"><i class="el-icon-coin"></i></div>
        <div class="stat-info">
          <div class="stat-label">实际收入</div>
          <div class="stat-value">¥ {{ profit }}</div>
        </div>
      </div>
      <div class="stat-card stat-refund">
        <div class="stat-icon"><i class="el-icon-refresh-left"></i></div>
        <div class="stat-info">
          <div class="stat-label">退款金额</div>
          <div class="stat-value">¥ {{ refund_total }}</div>
        </div>
      </div>
    </div>

    <div class="info-card mt20">
      <div class="info-card-head">
        <span class="info-card-title">账单列表</span>
      </div>
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.6)"
        max-height="600"
        :header-cell-style="{ background: '#fafafa', color: '#303133' }"
        stripe
      >
        <el-table-column
          type="index"
          label="序号"
          width="60"
          align="center">
          <template slot-scope="{$index}"> {{ $index + ((page_number - 1) * page_size ) + 1 }}</template>
        </el-table-column>
        <el-table-column prop="order_no" label="订单编号" align="center" minWidth="160" />
        <el-table-column prop="service_name" label="服务名称" align="center" />
        <el-table-column prop="order_created_at" label="下单时间" align="center" minWidth="150">
          <template slot-scope="{ row: { order_created_at } }">
            {{ (order_created_at * 1000) | formatDate('yyyy-MM-dd HH:mm:ss') }}
          </template>
        </el-table-column>
        <el-table-column label="订单金额" align="center">
          <template slot-scope="{ row: { total }}">
            <span class="money-text">￥{{ total }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付方式" align="center">
          <template slot-scope="{ row: { pay_type }}">
            <span>{{ pay_type | orderPayTypesFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付金额" align="center">
          <template slot-scope="{ row: { amount }}">
            <span class="money-text">￥{{ amount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderPayInfo" label="支付时间" align="center" minWidth="150">
          <template slot-scope="{ row: { cash_flow_created_at } }">
            <span v-if="cash_flow_created_at">{{ (cash_flow_created_at * 1000) | formatDate('yyyy-MM-dd HH:mm:ss') }}</span>
            <span v-else class="empty-text">—</span>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="金额类型" align="center" minWidth="90">
          <template slot-scope="{ row: { type } }">
            <el-tag size="mini" :type="type === 2 ? 'danger' : 'success'" effect="plain">{{ type | ordersPayTypeStatusFilter }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="患者信息" align="center" minWidth="190">
          <template slot-scope="{ row:{ name, tel }}">
            <div class="person-cell">
              <div class="person-name">{{ name || '—' }}</div>
              <div class="person-tel">{{ tel || '—' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="医院" align="center">
          <template slot-scope="{ row: { hospital_name } }">
            <span v-if="hospital_name">{{ hospital_name }}</span>
            <span v-else class="empty-text">—</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          background
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page_size"
          :current-page="page_number"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { fetchFinancialList } from '@/api'
import { OrderPayTypeStatus, OrderPayTypes } from '@/enum/orders'
import { filterEnum } from '@/utils/filter'
import { formatDate } from 'element-ui/lib/utils/date-util'
export default {
  name: 'OrdersManage',
  data() {
    return {
      OrderPayTypeStatus,
      OrderPayTypes,
      isAddNurse: false,
      fileList: [],
      search: {
        rangeDate: [
          formatDate(new Date(), 'yyyy-MM-dd 00:00:00'),
          formatDate(new Date(), 'yyyy-MM-dd 23:59:59')
        ],
        user_name: '',
        order_no: '',
        cash_flow_type: '',
        hospital_name: '',
        tel: ''
      },
      tableLoading: false,
      page_size: 10,
      page_number: 1,
      pay_total: 0,
      profit: 0,
      refund_total: 0,
      total: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      tableData: []
    }
  },
  filters: {
    formatDate,
    ordersPayTypeStatusFilter(val) {
      const list = OrderPayTypeStatus.map(i => ({
        ...i,
        val: i.val === 2 ? 0 : i.val
      }))
      return filterEnum(val, list).label || '-'
    },
    orderPayTypesFilter(val) {
      return filterEnum(val, OrderPayTypes).label || '-'
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      // status 0 超级管理员 1无权限 2有权限 默认1无权限
      this.getList()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.page_number = 1
      this.getList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.page_size = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.page_number = val
      this.getList()
    },
    searchData() {
      this.page_number = 1
      this.getList()
    },
    getList() {
      this.tableLoading = true
      const { page_size, page_number, search } = this
      const { rangeDate, ...searchInfo } = search
      const params = {
        page_size: page_size,
        page_number: page_number,
        ...searchInfo
      }
      if (rangeDate) {
        params.start_at = rangeDate[0]
        params.end_at = rangeDate[1]
      }
      this.tableLoading = true
      fetchFinancialList(params)
        .then(res => {
          if (res.status) {
            this.tableData = res.data.list
            this.total = res.data.total
            this.pay_total = res.data.pay_total
            this.profit = res.data.profit
            this.refund_total = res.data.refund_total
          } else {
            this.tableData = []
          }
        })
        .finally(() => {
          this.tableLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.financial-page {
  padding: 16px 20px 30px;
}
.page-header {
  padding-bottom: 14px;
  border-bottom: 1px solid #ececec;
}
.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}
.mt20 { margin-top: 20px; }
.mt15 { margin-top: 15px; }
.info-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 16px 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
}
.info-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid #f2f6fc;
}
.info-card-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  position: relative;
  padding-left: 10px;
}
.info-card-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 14px;
  background: #26a4b2;
  border-radius: 2px;
}
.stat-row {
  display: flex;
  gap: 16px;
}
.stat-card {
  flex: 1;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 18px 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
  position: relative;
  overflow: hidden;
  transition: box-shadow 0.2s;
}
.stat-card:hover { box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08); }
.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-right: 16px;
  flex-shrink: 0;
}
.stat-receivable .stat-icon { background: rgba(38, 164, 178, 0.12); color: #26a4b2; }
.stat-profit .stat-icon { background: rgba(103, 194, 58, 0.12); color: #67c23a; }
.stat-refund .stat-icon { background: rgba(245, 108, 108, 0.12); color: #f56c6c; }
.stat-info { flex: 1; }
.stat-label {
  font-size: 13px;
  color: #909399;
  margin-bottom: 6px;
}
.stat-value {
  font-size: 24px;
  font-weight: 600;
  color: #303133;
  line-height: 1.2;
}
.stat-receivable .stat-value { color: #26a4b2; }
.stat-profit .stat-value { color: #67c23a; }
.stat-refund .stat-value { color: #f56c6c; }
.money-text { color: #26a4b2; font-weight: 600; }
.empty-text { color: #c0c4cc; }
.person-cell { line-height: 1.6; }
.person-name { color: #303133; font-weight: 500; }
.person-tel { color: #909399; font-size: 13px; }
.block {
  text-align: center;
  margin-top: 20px;
}
</style>
